const colors = {
    primary: '#0367e9',
    darkGrey: '#2c2e36',
    lightGrey: '#a0a0a0',
    white: '#f0f0f0',
    black: '#202126',
};
export default colors;
